/**
 * Écran d'accès : échange du lien personnel contre une session.
 *
 * Cas nominal : le participant arrive par /acces?jeton=… depuis l'e-mail de la
 * billetterie — l'échange est automatique, il ne voit jamais cet écran. La
 * saisie manuelle couvre le lien perdu (le code est réimprimable sur le badge).
 */
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { envoyer } from '../reseau.ts';
import { useSession } from '../etat.tsx';
import { Marque, MotMarque } from '../composants/Marque.tsx';
import { Champ } from '../composants/Formulaires.tsx';

export function Acces() {
  const [parametres] = useSearchParams();
  const naviguer = useNavigate();
  const { recharger } = useSession();
  const [jeton, setJeton] = useState('');
  const [erreur, setErreur] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);

  const echanger = async (valeur: string) => {
    setEnCours(true);
    setErreur(null);
    const reponse = await envoyer('/api/acces/echanger', { jeton: valeur.trim() });
    setEnCours(false);
    if (reponse.erreur) {
      setErreur(reponse.erreur);
      return;
    }
    await recharger();
    naviguer('/bienvenue', { replace: true });
  };

  useEffect(() => {
    const depuisUrl = parametres.get('jeton');
    if (depuisUrl) void echanger(depuisUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="acces">
      <div className="acces__marque">
        <Marque taille={56} />
        <MotMarque />
      </div>
      <h1 className="acces__titre">Votre accès à l'événement</h1>
      <p className="acces__texte">
        Utilisez le lien reçu par e-mail, ou saisissez le code d'accès imprimé sur votre badge.
      </p>

      <form
        className="acces__formulaire"
        onSubmit={(e) => {
          e.preventDefault();
          if (jeton.trim()) void echanger(jeton);
        }}
      >
        <Champ
          label="Code d'accès"
          value={jeton}
          onChange={(e) => setJeton(e.target.value)}
          placeholder="ex. k3v9…"
          autoComplete="off"
          autoCapitalize="off"
          spellCheck={false}
        />
        {erreur && <p className="message-erreur">{erreur}</p>}
        <button type="submit" className="bouton" disabled={enCours || !jeton.trim()}>
          {enCours ? 'Vérification…' : 'Entrer'}
        </button>
      </form>

      <p className="acces__sponsor">Offert par Elite Lead</p>
    </div>
  );
}
